
































































































import { Component, Vue } from 'vue-property-decorator';
import { readFarms } from '@/store/farm/getters';
import { dispatchGetFarms, dispatchGetFarmInfo, dispatchGetOneFarm } from '@/store/farm/actions';
import FarmAuthorizationStatus from '@/components/FarmAuthorizationStatus.vue';
import FarmRequestRegistrationDialog from '@/components/FarmRequestRegistrationDialog.vue';
import FarmTagsChips from '@/components/FarmTagsChips.vue';
import {FarmProfile} from '@/interfaces';

@Component({
    components: {FarmAuthorizationStatus, FarmRequestRegistrationDialog, FarmTagsChips},
})
export default class Farms extends Vue {
  public search = '';
  public headers = [
    {
        text: 'Active',
        sortable: true,
        value: 'active',
        align: 'left',
    },
    {
      text: 'Farm Name',
      sortable: true,
      value: 'farm_name',
      align: 'left',
    },
    {
      text: 'URL',
      sortable: true,
      value: 'url',
      align: 'left',
    },
    {
      text: 'Authorized',
      sortable: true,
      value: 'is_authorized',
      align: 'left',
    },
    {
        text: 'Tags',
        sortable: true,
        value: 'tags',
        align: 'left',
    },
    {
      text: 'API Version',
      sortable: true,
      value: 'info.api_version',
      align: 'left',
    },
    {
      text: 'Last Accessed',
      sortable: true,
      value: 'last_accessed',
      align: 'left',
    },
   {
      text: 'Created',
      sortable: true,
      value: 'time_created',
      align: 'left',
    },
    {
      text: 'Actions',
      sortable: false,
      value: 'action',
    },
  ];

  public loading: boolean = false;

  get farms() {
    return readFarms(this.$store);
  }

  public async mounted() {
    await dispatchGetFarms(this.$store);
  }

  public async loadFarmInfo(farmID) {
      this.loading = true;
      await dispatchGetFarmInfo(this.$store, {farmID}).then( (info) => {
            dispatchGetOneFarm(this.$store, {farmID}).then( (response) => {
                this.loading = false;
            });
          },

      );
  }
}
